var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-meter",attrs:{"data-strength":_vm.strength}},_vm._l((_vm.segments),function(i){return _c('div',{key:i,staticClass:"password-meter__segment"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }